import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./bridgeStoreModule";

export default function useBridge() {

    // Table Handlers
  const tableColumns = ref([
      { key: 'bridge',
        label: 'мост',
      },
      { key: 'platform',
        label: 'платформа',
      },
      { key: 'user',
        label: 'пользователь',
      },
  ])

  const setupData = {
      formModel: {
          name:'',
          object_type:'',
          number: '',
          platform: '',
          user: ''
      },
  }

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {

    addDataUrl,
    fetchDataUrl,

    tableColumns,
    setupData,
  }
}
